import type { GetServerSideProps, NextPage } from "next"
import { NavBar } from "../../src/components/universal/NavBar"
import { Footer } from "../../src/components/universal/Footer"
import { PageHeader } from "../../src/components/universal/PageHeader"
import { useState } from "react"
import { PageShade } from "../../src/components/universal/PageShade"
import { PageMeta } from "../../src/components/universal/PageMeta"
import { GeneralForm } from "../../src/components/contactForms/GeneralContact"
import { RewardForm } from "../../src/components/contactForms/RewardForm"
import { TechnicalForm } from "../../src/components/contactForms/TechnicalForm"

type Props = {
  brands: { name: string; affiliate_status: string }[]
}

// Images
import pageShade from "/public/images/shades/help.png"
import { HelpCard } from "../../src/components/cards/HelpCard"

const Contact: NextPage<Props> = (props) => {
  const [form, setForm] = useState<string>("general")

  return (
    <div>
      <PageMeta title={"Support"} theme={"#F3F4F7"} description={"Contact us about any general or Technical issues or Missing Rewards."} />
      <PageShade image={pageShade} />
      <main>
        <NavBar />

        <PageHeader title="Support" caption="Send us a message and we’ll get back to you as soon as we can." />

        {/* Help cards */}
        <section>
          <div className="wrapper get-help">
            <h3>Get Help</h3>

            <div className="cards-wrapper">
              <HelpCard
                link="/help/faqs"
                title="FAQs"
                caption="Ruby lets you combine every way to save: loyalty points, sales, coupons, and cash back. Find the best deals, browse your favorite stores, and checkout - all on the app."
              />

              <HelpCard
                link="/help/get-started"
                title="Getting started"
                caption={`Here, you'll find everything you need to know about the Ruby app. How it works, where to get it, and how to make your first saving with Ruby.`}
              />

              <HelpCard
                link="/help/stacked-savings"
                title="Stacked savings"
                caption="There’s an endless number of offers, coupons, sales, and loyalty programs released everyday. Finding the best deal - and combing through the Terms & Conditions to see which savings you can combine - is time-consuming."
              />
            </div>
          </div>
        </section>

        {/* Contact forms */}
        <section>
          <div className="wrapper contact-forms">
            <h3>Contact us</h3>

            <div className="tabs">
              <button onClick={() => setForm("general")} className={"btn-lg-label round " + (form == "general" && " bg-primary secondary")}>
                General
              </button>
              <button onClick={() => setForm("technical")} className={"btn-lg-label round " + (form == "technical" && " bg-primary secondary")}>
                Technical support
              </button>
              <button onClick={() => setForm("rewards")} className={"btn-lg-label round " + (form == "rewards" && " bg-primary secondary")}>
                Missing Rewards
              </button>
            </div>

            <div className="forms-wrapper">
              {form == "general" && <GeneralForm />}
              {form == "technical" && <TechnicalForm />}
              {form == "rewards" && (
                <>
                  <RewardForm brands={props.brands} />
                  <div className="notes">
                    <h5>Important Notes</h5>
                    <ul>
                      <li>It typically takes 24-48 hours for cash back to post to your account.</li>
                      <li>Certain brands report cash back to us on a less-frequent basis, such as once a week.</li>
                      <li>Travel companies may not report cash back until you have completed your stay.</li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const listBrands = await import("../../src/store_names.json")

  return {
    props: {
      brands: listBrands.default,
    },
  }
}

export default Contact
